"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertNeutralColor = exports.capitalize = void 0;

var capitalize = function capitalize(stringVal) {
  return stringVal.charAt(0).toUpperCase() + stringVal.slice(1);
};

exports.capitalize = capitalize;

var convertNeutralColor = function convertNeutralColor(color, defaultColor) {
  var convertColor = color === 'neutral' ? 'default' : color;
  return convertColor || defaultColor || 'default';
};

exports.convertNeutralColor = convertNeutralColor;